"use strict";
import { Group } from "react-art";
import DragPoint from "./drag_point";
import DrawingUtils from "../../util/drawing_utils";
import { getDisplayName } from "./utils";
const { PropTypes } = DrawingUtils;
export default (AnnotationComponent) => {
  const DragPoints = ({
    dragPoints,
    hovered = false,
    hoveredDragPointIndex
  }) => {
    let dragPointViews = null;
    if (hovered) {
      dragPointViews = dragPoints.map((dragPoint, i) => {
        return /* @__PURE__ */ React.createElement(
          DragPoint,
          {
            position: dragPoint,
            hovered: hoveredDragPointIndex === i,
            key: i
          }
        );
      });
    }
    return /* @__PURE__ */ React.createElement(Group, null, dragPointViews);
  };
  DragPoints.propTypes = {
    dragPoints: React.PropTypes.arrayOf(PropTypes.Vector).isRequired,
    hovered: React.PropTypes.bool,
    hoveredDragPointIndex: React.PropTypes.oneOfType([
      // index of connector being hovered
      React.PropTypes.number,
      React.PropTypes.bool
    ])
  };
  DragPoints.displayName = `DragPointsFor(${getDisplayName(AnnotationComponent)})`;
  return DragPoints;
};
